document.addEventListener("DOMContentLoaded", () => {
  const forms = document.querySelectorAll('form[action^="/cart/add"]');

  forms.forEach(form => {
    const requiredFiles = form.querySelectorAll('input[type="file"][data-required="true"]');

    // Image preview & hide error on change
    requiredFiles.forEach(fileInput => {
      const sectionId = fileInput.id.split("-").pop();
      const errorDiv = document.getElementById(`CustomImageError-${sectionId}`);
      const previewDiv = document.getElementById(`CustomImagePreview-${sectionId}`);

      fileInput.addEventListener("change", e => {
        errorDiv.style.display = "none";
        previewDiv.innerHTML = "";
        const file = e.target.files[0];
        if (file) {
          const img = document.createElement("img");
          img.src = URL.createObjectURL(file);
          img.style.maxHeight = "50px";
          img.style.display = "block";
          previewDiv.appendChild(img);
        }
      });
    });

    // Form submit validation
    form.addEventListener("submit", e => {
      let valid = true;

      requiredFiles.forEach(fileInput => {
        const sectionId = fileInput.id.split("-").pop();
        const errorDiv = document.getElementById(`CustomImageError-${sectionId}`);

        if (!fileInput.files.length) {
          valid = false;
          errorDiv.style.display = "block";
          fileInput.focus();
        }
      });

      if (!valid) {
        e.preventDefault();
        e.stopImmediatePropagation();
      }
    });
  });
});
